"use strict";

exports.__esModule = true;
exports.visuallyHidden = void 0;

var _styledComponents = require("styled-components");

/**
 * Hide the content to which this is applied visually, but not from screen
 * readers.
 */
var visuallyHidden = (0, _styledComponents.css)(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n"]);
exports.visuallyHidden = visuallyHidden;